/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-11-05 17:07:10
 *
 *******************************************************/
// @flow

import _ from 'lodash';

import { removeUnexpectedCharsInTerms, checkHasSpecialCharacters } from 'src/helpers';

/**
 * Check the suggestions list is empty
 *
 * @param  {array} suggestions
 *                 [
 *                   {
 *                     term: <string>
 *                     priority: <number>
 *                     search_enabled: <boolean>
 *                   }
 *                 ]
 *
 * @return {boolean}  the list is empty or not
 */
export const isEmptySuggestions = suggestions => {
  const suggestion = _.find(suggestions, item => {
    const term = removeUnexpectedCharsInTerms(item.term);
    return !_.isEmpty(term);
  });

  return suggestion ? false : true;
};

/**
 * Check validate suggestions
 *
 * @param  {array} suggestions
 *                 [
 *                   {
 *                     term: <string>
 *                     priority: <number>
 *                     search_enabled: <boolean>
 *                   }
 *                 ]
 *
 */
export const checkValidateSuggestions = suggestions => {
  for (let suggestion of suggestions) {
    if (suggestion.term.length > 128) {
      return 'AdminHTML.SuggestionDictionary.Validate.invalid_SuggestionTerm_Length';
    }

    const checkSpecialCharactersValue = checkHasSpecialCharacters(suggestion.term);
    if (
      (_.isEmpty(suggestion.term.trim()) || checkSpecialCharactersValue) &&
      !_.isEmpty(suggestion.id)
    ) {
      return 'AdminHTML.SuggestionDictionary.Validate.invalid_SuggestionTerm_SpecialCharacter';
    }
  }
  return '';
};
